// src/pages/Login.jsx
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  const location = useLocation();
  const [message, setMessage] = React.useState(location.state?.message || null);
  
  // Clear message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [message]);
  
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto bg-white shadow-md rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-800 px-6 py-8 text-white text-center">
            <h1 className="text-3xl font-bold">Welcome Back!</h1>
            <p className="mt-2">Log in to your Tantravani account</p>
          </div>
          
          <div className="p-6">
            {message && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-6">
                <p>{message}</p>
              </div>
            )}
            
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;